module.exports = __webpack_public_path__ + "img/articles1.79642cf7.svg";